interface IBlankCircleIconProps extends React.SVGProps<SVGSVGElement> {
  isError?: boolean;
}

const BlankCircleIcon = ({ isError = false, className, ...props }: IBlankCircleIconProps) => {
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" className={className} {...props}>
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0V0C12.4183 0 16 3.58172 16 8V8C16 12.4183 12.4183 16 8 16V16C3.58172 16 0 12.4183 0 8V8Z"
        fill="white"
        fillOpacity="0.05"
      />
      <path
        d="M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5Z"
        stroke={isError ? '#FC4646' : 'white'}
        strokeOpacity={isError ? '1' : '0.2'}
      />
    </svg>
  );
};

export default BlankCircleIcon;
